import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class NotificationManagementAPI implements IAPI {
  prefix = '/NotificationManagement'

  fetchList (params: TNotificationManagementAPI.Params.FetchList) {
    const url = appendParams(`${this.prefix}/Get`, { ...params })
    return API.get<TNotificationManagement.TState['notificationList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TNotificationManagement.TState['notificationDetail']>(`${this.prefix}/GetById?id=${id}`)
  }

  deleteNotification (id: string) {
    return API.delete<TNotificationManagement.TState['notificationDetail']>(`${this.prefix}/${id}`)
  }

  async publishNotification (data: any) {
    const response = await API.post<TNotificationManagement.TState['notificationDetail']>(`${this.prefix}/Add`, data)
    return response.data
  }

  async updateNotification (data: any) {
    const response = await API.put<TNotificationManagement.TState['notificationDetail']>(`${this.prefix}/Update`, data)
    return response.data
  }
}

export const notificationManagementAPI = new NotificationManagementAPI()
